import styled from 'styled-components';

export const RadioText = styled.span`
  @media only screen and (max-device-width: 640px) {
    white-space: normal !important;
  }
`;
